// App.jsx
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { VideoProvider } from "./context/VideoContext";
import Layout from "./components/Layout/Layout";
import AuthGuard from "./components/auth/AuthGuard";
import GoogleOAuthHandler from "./components/auth/GoogleOAuthHandler";
import PaymentVerification from "./components/Purchase/PaymentVerification";
import SubscriptionPage from "./pages/SubscriptionPage/SubscriptionPage";
import DeleteAccountPage from "./pages/DeleteAccountPage/DeleteAccountPage";
import Info from "./pages/Info/Info";
import "./App.css";
import { ShadowTechniqueProvider } from "./context/ShadowTechniqueContext";
import { SubtitleSettingsProvider } from "./context/SubtitleSettingsContext";
import { NotificationProvider } from "./context/NotificationContext";
import { SelectedSubtitlesProvider } from "./context/SelectedSubtitlesContext";
import { PackagesModalProvider } from "./context/PackagesModalContext";
import { ThemeProvider } from "./context/ThemeContext";
import Comparesrt from "./components/Comparesrt/Comparesrt";
import VoteLayout from "./pages/Vote/VoteLayout";
import VoteHome from "./pages/Vote/VoteHome";
import VoteFAQs from "./pages/Vote/VoteFAQs";
import MyVotes from "./pages/Vote/MyVotes";
import CollectionVote from "./pages/Vote/CollectionVote";

function App() {
  return (
    <ThemeProvider>
    <Router>
      <VideoProvider>
        <SubtitleSettingsProvider>
          <ShadowTechniqueProvider>
            <NotificationProvider>
              <SelectedSubtitlesProvider>
                <PackagesModalProvider>
                  <Routes>
                    <Route
                      path="/googlelogin"
                      element={<GoogleOAuthHandler />}
                    />
                  </Routes>
                  <AuthGuard>
                    <Routes>
                      <Route path="/" element={<Layout />} />
                      <Route
                        path="/payment/verify/:orderId"
                        element={<PaymentVerification />}
                      />
                      <Route
                        path="/Subscription"
                        element={<SubscriptionPage />}
                      />
                      <Route path="/comparesrt" element={<Comparesrt />} />
                      <Route path="/info" element={<Info />} />
                      <Route
                        path="/deleteaccount"
                        element={<DeleteAccountPage />}
                      />
                      <Route path="/vote" element={<VoteLayout />}>
                        <Route index element={<VoteHome />} />
                        <Route path="FAQs" element={<VoteFAQs />} />
                        <Route path="MyVotes" element={<MyVotes />} />
                        <Route
                          path="collections/:collectionId"
                          element={<CollectionVote />}
                        />
                        <Route
                          path="*"
                          element={<Navigate to="/vote" replace />}
                        />
                      </Route>
                    </Routes>
                  </AuthGuard>
                </PackagesModalProvider>
              </SelectedSubtitlesProvider>
            </NotificationProvider>
          </ShadowTechniqueProvider>
        </SubtitleSettingsProvider>
      </VideoProvider>
    </Router>
    </ThemeProvider>
  );
}

export default App;
